import React from "react";
// import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { isAuthenticate } from "../../commons/utils";

class PrivateRoute extends React.Component {
  render() {
    let { user } = this.props;
    return (
      <Route
        render={() => {
          return isAuthenticate(user) ? (
              <this.props.component />
          ) : (
            <Redirect to="/" />
          );
        }}
      />
    );
  }
}

export default PrivateRoute;
